<template>
  <div>
    <van-nav-bar fixed title="选择车检通道" left-arrow @click-left="goBack"/>
    <div class="v_mainBox">
      <div class="van-boxLin">
        <h4>如果您想在线预约检车，请选择</h4>
        <p>在线预约，免排队</p>
        <van-button type="primary" block @click="green">绿色通道</van-button>
      </div>
      <div class="van-boxLin line2">
        <h4>如果您已到达检车站，请选择</h4>
        <p>自助智能登录，一键式登录</p>
        <van-button type="primary" block @click="goucheck">到站检车</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "check",
  data() {
    return {}
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    green() {
      this.$router.push({path: '/greenChannel'})
    },
    goucheck() {
      this.$router.push({path: '/goCheck'})
    }
  }
}
</script>

<style scoped>
.v_mainBox {
  padding-top: 50px;
}

.van-boxLin {
  width: 90%;
  height: auto;
  margin: 15% auto;
  display: block
}

.line2 {
  margin-top: 5%;
  border-top: 1px solid #eee;
  padding-top: 10%
}

.van-boxLin h4, .van-boxLin p {
  text-align: center;
  margin: 10px 0;
}

.van-button--primary {
  background-color: #3778d0;
  border: 1px solid #3778d0;
  height: 60px;
  width: 70%;
  font-size: 16px;
  margin: auto;
  border-radius: 10px;
  margin-top: 15px;
}
</style>
